import { SectionProps } from '../SectionProps';
import { Grid, Typography } from '@material-ui/core';
import { SocItemDetailsAo } from '../../../domain/SocItemDetailsAo';
import { KloeFileUpload } from '../KloeFileUpload';

export const QuestionThreeSection: React.FC<{
  sectionProps: SectionProps<SocItemDetailsAo>;
}> = ({ sectionProps }) => {
  return (
    <>
      <KloeFileUpload sectionProps={sectionProps} kloeType="KLOE1" />
    </>
  );
};
